export const MIC_TEST_DURATION = 5000;

export const DEMO_VIDEO_WATCHED_LOCAL_STORAGE_FLAG = 'lantern-assessment-demo-video-watched';

export const INSTRUCTIONS_CARDS_IDS = {
    DEMO_VIDEO_CARD: 'demo_video_card',
    MIC_PERMISSION_CARD: 'mic_permission_card',
    MIC_TEST_CARD: 'mic_test_card',
    MIC_READING_CHECK_CARD: 'mic_reading_check_card',
    MULTI_CHOICE_READING_CHECK_CARD: 'multi_choice_reading_check_card'
};

export const CARDS_CLASSNAMES = {
    [INSTRUCTIONS_CARDS_IDS.DEMO_VIDEO_CARD]: 'demo-video-card',
    [INSTRUCTIONS_CARDS_IDS.MIC_PERMISSION_CARD]: 'mic-permission-card',
    [INSTRUCTIONS_CARDS_IDS.MIC_TEST_CARD]: 'mic-test-card',
    [INSTRUCTIONS_CARDS_IDS.MIC_READING_CHECK_CARD]: 'mic_reading_check_card',
    [INSTRUCTIONS_CARDS_IDS.MULTI_CHOICE_READING_CHECK_CARD]: 'multi_choice_reading_check_card'
};

export const INSTRUCTIONS_CARDS_ORDER = {
    [INSTRUCTIONS_CARDS_IDS.MIC_PERMISSION_CARD]: 0,
    [INSTRUCTIONS_CARDS_IDS.MIC_TEST_CARD]: 1,
    [INSTRUCTIONS_CARDS_IDS.MIC_READING_CHECK_CARD]: 2,
    [INSTRUCTIONS_CARDS_IDS.MULTI_CHOICE_READING_CHECK_CARD]: 3,
    [INSTRUCTIONS_CARDS_IDS.DEMO_VIDEO_CARD]: 4,
};

export const MIC_PERMISSION_STATUSES = {
    DENIED: 'denied',
    PROMPT: 'prompt',
    GRANTED: 'granted',
};

export const VERIFICATION_STATUS = {
    IDLE: 'IDLE',
    COMPLETE: 'COMPLETE',
    PENDING: 'PENDING',
    ERROR: 'ERROR',
};

export const VERIFICATION_RESULT = {
    UNAVAILABLE: 'unavailable',
    PASSED: 'passed',
    FAILED: 'failed',
};

export const MIC_FAILURE_TYPES = {
    MIC_TEST_ERROR: 'MIC_TEST_ERROR',
    SECOND_MIC_TEST_FAILED: 'SECOND_MIC_TEST_FAILED',
    THIRD_MIC_TEST_FAILED: 'THIRD_MIC_TEST_FAILED',
    ACCESS_FAILED: 'ACCESS_FAILED',
    ACCESS_DENIED: 'ACCESS_DENIED',
};

export const MIC_FAILURE_MESSAGE = {
    [MIC_FAILURE_TYPES.MIC_TEST_ERROR]: `An unexpected 503 error has occurred. Our system encountered an error and can't analyze your student's reading.
    Please make a note of the error code, and contact us at edsupport@amplify.com or on live chat so we can investigate.`,
    [MIC_FAILURE_TYPES.SECOND_MIC_TEST_FAILED]: `The student isn't reading loudly enough to pass the microphone test.
        Tell the student to read out loud as clearly as possible and start the microphone test again.`,
    [MIC_FAILURE_TYPES.THIRD_MIC_TEST_FAILED]: `Our system shows that the student is not reading loudly or clearly enough to proceed with the assessment.
         If you have questions, please contact us at edsupport@amplify.com or on live chat.`,
    [MIC_FAILURE_TYPES.ACCESS_FAILED]: 'Educators: microphone access failed.',
    [MIC_FAILURE_TYPES.ACCESS_DENIED]: 'Educators: microphone access was denied.',
};

export const MIC_FAILURE_MESSAGE_AR = {
    ...MIC_FAILURE_MESSAGE,
    [MIC_FAILURE_TYPES.ACCESS_FAILED]: 'Microphone access failed.',
    [MIC_FAILURE_TYPES.ACCESS_DENIED]: 'Microphone access was denied.',
};

export const NEXT_CARD_INCREMENT = 1;

export const SKIP_NEXT_INCREMENT = 2;
